import React, { useState, useEffect, useMemo, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "reducers/rootReducer";
import { formatForRedis } from "utils/appUtil";
import { Select } from "antd";
import {
  SocketTopics,
  UserTopics,
  ExtendedBioTopics,
} from "../../constants/enums";
import {
  getVehicleTypesPath
} from "../../hooks/socketConstants";
import useSocketActions from "../../hooks/socketActions";
import { useLocation } from "react-router-dom";
import { getVehicleTypesTopic } from "hooks/MQTTConstants";

const { Option } = Select;

const VehicleTypeInput = (props: any) => {
  const { value, placeholder, onChange, socket } = props;
  const { projects, users_filter, encrypted_token } = useSelector(
    (state: RootState) => state.auth
  );
  const { search } = useLocation();

  const defaultPagination = 50;
  const [page, setPage] = useState(0);
  const [searching, setSearching] = useState(false);
  const [pagination, setPagination] = useState(true);
  const [options, setOptions] = useState([]);
  const dispatch = useDispatch();
  const { getUserRequestPayload } = useSocketActions();

  let timeout;

  const getVehicleType = () => {
    // const query = new URLSearchParams(search);
    // const connectionId = query.get("connectionId");
    setSearching(true);
    socket.publishToServiceIdSurvey(
      SocketTopics.SurveyTopics,
      UserTopics.SearchInUser,
      getUserRequestPayload(
        projects?.adminUserId,
        "$",
        getVehicleTypesPath()
      ),
      getVehicleTypesTopic(encrypted_token?.connectionId),
      projects?.userServiceId
    );
  }

  useEffect(() => {
    if (projects?.userServiceId) {
      // const query = new URLSearchParams(search);
      // const connectionId = query.get("connectionId");
      socket.subscribeToSurvey(
        SocketTopics.SurveyTopics,
        getVehicleTypesTopic(encrypted_token?.connectionId),
        (response) => {
          console.log("vehicle type", response?.data?.[0]?.[0]);
          setSearching(false)
          const opts = response?.data?.[0]?.[0]
            ?.map((x) => {
              return {
                id: x._id,
                name: x.name,
                obj: x,
              };
            })
            .filter((x) => {
              return !options.find((y) => {
                return x.id === y.id;
              });
            }) || [];
          setOptions([...options, ...opts]);
        }
      );
    }
  }, [projects?.userServiceId]);

  // useEffect(() => {
  //   if (users_filter) {
  //     setSearching(false);
  // const opts = users_filter
  //   ?.map((x) => {
  //     return {
  //       id: x.id,
  //       name: x.name,
  //       obj: x,
  //     };
  //   })
  //   .filter((x) => {
  //     return !options.find((y) => {
  //       return x.id === y.id;
  //     });
  //   });
  // setOptions([...options, ...opts]);
  //     if (opts.length === 0) {
  //       setPagination(false);
  //     }
  //   }
  // }, [users_filter]);

  return (
    <Select
      showSearch
      // mode={"multiple"}
      allowClear={true}
      className="w-full"
      value={value?.value}
      placeholder={placeholder}
      // disabled={adminRoles === undefined}
      onChange={(value) => {
        // const changes = [];
        // values.map((value) => {
        //   const responder = options.find((x) => {
        //     return x.id === value;
        //   });
        //   changes.push({
        //     id: value,
        //     ...responder.obj,
        //   });
        // });
        const type = options.find((x) => {
          return x.id === value;
        });
        onChange({
          type: "vehicleType",
          // responders: changes,
          value,
          name: type?.name
        });
      }}
      loading={searching}
      filterOption={(input, option) =>
        (option!.children as unknown as string)
          .toLowerCase()
          .includes(input.toLowerCase())
      }
      onFocus={() => {
        if (projects?.userServiceId) {
          getVehicleType();
        }
      }}
      onSearch={(search) => {
        // if (timeout) clearTimeout(timeout);
        // timeout = setTimeout(() => {
        //   if (search && search !== "") {
        //     getUsers(0, search);
        //     setPagination(false);
        //   } else getUsers(0);
        // }, 500);
      }}
      onPopupScroll={(e: any) => {
        // e.persist();
        // let target = e.target;
        // if (target.scrollTop + target.offsetHeight === target.scrollHeight) {
        //   if (pagination) {
        //     getUsers(page + 1);
        //   }
        // }
      }}
    >
      {options?.map((option, index) => (
        <Option key={index} value={option.id}>
          {option.name}
        </Option>
      ))}
    </Select>
  );
};

export default VehicleTypeInput;
